// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var distributionRouter = {
  path: '/distribution',
  component: Layout,
  redirect: '/distribution/distributionconfig',
  name: 'Distribution',
  meta: {
    title: '分销',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/distribution/index');
    },
    name: 'distributionIndex',
    meta: {
      title: '分销员管理',
      icon: ''
    }
  }, {
    path: 'apply',
    component: function component() {
      return import('@/views/distribution/apply/index');
    },
    name: 'distributionApply',
    meta: {
      title: '分销员申请',
      icon: ''
    }
  }, {
    path: 'userBinding',
    component: function component() {
      return import('@/views/distribution/userBinding/index');
    },
    name: 'distributionUserBinding',
    meta: {
      title: '微站绑定管理',
      icon: ''
    }
  }, {
    path: 'recordList',
    component: function component() {
      return import('@/views/distribution/recordList/index');
    },
    name: 'distributionRecordList',
    meta: {
      title: '分销日志',
      icon: ''
    }
  }, {
    path: 'distributionconfig',
    component: function component() {
      return import('@/views/distribution/config/index');
    },
    name: 'distributionConfig',
    meta: {
      title: '分销配置',
      icon: ''
    }
  }]
};
export default distributionRouter;